<template>
  <div>
    <a-row>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                :actions="master.actions"
                @action="masterAction"
                ref="masterComponent"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Estado')" v-bind="fiOptions">
                <a-select
                  v-decorator="[
                    'status',
                    { rules: [{ required: false}], initialValue: 'I' },
                  ]"
                >
                  <a-select-option value="A">
                    ACTIVO
                  </a-select-option>
                  <a-select-option value="I">
                    INACTIVO
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="offices"
                          :label="$t('Office') "
                          :formItemConfig="fiOptions"
                          :decorator="['office_id', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :params="locationUser"
              >
              </g-dropdown>
            </a-col>

          </a-row>
        </template>
      </g-master>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'location_user',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Oficina', dataIndex: 'office_name', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'office_id'},
            {name: 'status'}
          ],
          actions: [
            {
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'}
            },
            {
              name: 'createAll',
              text: 'Agregar todas',
              permisos: [],
              props: {icon: 'plus', type: 'button'}
            }
          ]
        },
        locationUser: {
          location_user: true
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'createAll':
            this.$confirm({
              title: 'Agregar todas',
              content: '¿Está seguro que desea agregar todas?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().get('location_user_/all', {
                    params: {
                      'user_id': this.name
                    }
                  })
                    .then((response) => {
                      this.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible agregar todas'))
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
        }
      },
      loadData () {
        this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
      }
    },
    props: ['name'],
    computed: {
      parentData () {
        return {
          user_id: this.name
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/LocationUser.vue